module.exports = __webpack_public_path__ + "static/media/bmc-logo.33eefed6.svg";